import { Box } from "@mui/material"
import { DataGrid } from "@mui/x-data-grid"
import { useEffect, useState } from "react"

const DEFAULT_PAGINATION_MODEL = {
  page: 0,
  pageSize: 10
}

export default function DataTablePagination({columns, rows, onRowClick, loading, style, onPageChange, rowCount, ...props}){
  const [paginationModel, setPaginationModel] = useState(DEFAULT_PAGINATION_MODEL)

  function resetTable(){
    setPaginationModel(DEFAULT_PAGINATION_MODEL)
  }

  useEffect(() => {
    onPageChange(paginationModel.page, paginationModel.pageSize)
  }, [paginationModel])

  return (
    <Box style={rows.length > 5 ? {} : {height: '50vh'}}>
      <DataGrid
        style={style}
        columns={columns}
        rows={rows}
        loading={loading}
        onRowClick={onRowClick}
        rowCount={rowCount}
        paginationMode="server"
        paginationModel={paginationModel}
        onPaginationModelChange={setPaginationModel}
        pageSizeOptions={[5, 10, 20, 25]}
        {...props}
      />
    </Box>
  )
}